import { render, staticRenderFns } from "./SetReadOnly.vue?vue&type=template&id=0ba3fbb9"
import script from "./SetReadOnly.vue?vue&type=script&lang=js"
export * from "./SetReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports